"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormsStore_1 = require("./FormsStore");
exports.default = FormsStore_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/data/FormsStore/index.js
// module id = 37
// module chunks = 0 1